import axios from "axios";
import { useEffect, useState } from "react";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmt = (n) => {
  const v = Number(n) || 0;
  return `$${v.toFixed(v % 1 === 0 ? 0 : 2)}`;
};

export function useProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    api
      .get("/products")
      .then((r) => alive && setProducts(r.data))
      .catch(() => {})
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, []);
  return { products, loading };
}

export const ANGEL_NUMBERS = [
  { n: "111", title: "New Beginnings", desc: "A door opens. The first signal that your thoughts are becoming your path. Start the thing." },
  { n: "222", title: "Trust Your Path", desc: "Nothing is random. The delays, the detours, the encounters — all coordinates on your map." },
  { n: "333", title: "Growth", desc: "You are expanding in directions you cannot see yet. Keep going. The process is the point." },
  { n: "444", title: "Protection", desc: "You are exactly where you need to be. Something is holding the line while you build." },
  { n: "555", title: "Change", desc: "Motion before the sign is obvious. What is leaving was never meant to stay." },
];

